import { ButtonBase, SxProps } from '@mui/material';
import { FC, useEffect, useRef } from 'react';
import { RailroadIssueFullPage } from './RailroadIssueFullPage';
import { RailroadFullPage } from './utils';

export const FullscreenRailroadMiniature: FC<{
  pages: RailroadFullPage[];
  pageIndex: number;
  sx?: SxProps;
  selected?: boolean;
  onSelect: () => void;
}> = ({ pages, pageIndex, sx, selected, onSelect }) => {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (selected) {
      ref.current?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  }, [selected]);

  return (
    <ButtonBase
      ref={ref}
      onClick={() => onSelect()}
      sx={{
        mr: 2,
      }}
    >
      <RailroadIssueFullPage
        pages={pages}
        pageIndex={pageIndex}
        selected={selected}
        displayOptions={{
          displayBorders: true,
          displayThumbnails: true,
          size: 4,
          miniature: true,
          displayInfos: false,
          displayPageNumber: true,
        }}
        containerSx={sx}
      />
    </ButtonBase>
  );
};
